/**
 * Full Stack FastAPI MARIADB
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * DTO for receiving progress updates from the IA pipeline.
 */
export interface LabProgressUpdate { 
    /**
     * UUID of the video
     */
    video_id: string;
    /**
     * Current stage key
     */
    stage: string;
    progress_percentage?: number | null;
    queue_position?: number | null;
    /**
     * Flag to indicate if this update is an error
     */
    is_error?: boolean;
    message?: string | null;
    timestamp?: string;
}

